module.exports = {"140824100":"稷峰镇","140824101":"西社镇","140824102":"化峪镇","140824103":"翟店镇","140824104":"清河镇","140824200":"蔡村乡","140824201":"太阳乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140824.json
// module id = 296
// module chunks = 0